module.exports = __webpack_public_path__ + "static/media/pdo03.d3c6a0cb.jpg";